<template>
  <div class="flex position-relative" :style="`height:${iconSize}px`">
    <i class="material-icons icon-info unselect"
       :style="{fontSize: iconSize+'px'}"
       @mouseover="mouseOver"
       @mouseleave="vTooltip=false">{{ icon }}</i>
    <div class="box-tooltip" v-if="vTooltip"
         :style="`width:${computedWidth}px;top:30px;${computedPosition}`">
      <div class="tool-tip-text">{{ text }}</div>
      <div v-if="textPrimary" class="tool-tip-text-primary">{{ textPrimary }}</div>
      <!--<div class="triangle"></div>-->
      <!--<div class="tool-tip-outside" @click="vTooltip=false"></div>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "ToolTip",
    props: {
      icon: {
        type: String,
        default: 'info'
      },
      text: {
        type: String
      },
      textPrimary: {
        type: String
      },
      iconSize: {
        type: Number,
        default: 18
      }
    },
    created() {

    },
    methods: {
      mouseOver(e) {
        this.vTooltip = true;
        if(window.innerWidth * 2/3 < e.pageX) {
          this.computedPosition = 'right:0px';
        } else {
          this.computedPosition = 'left:0px';
        }
      }
    },
    computed: {
      computedWidth() {
        if(this.isMobile) {
          return 300
        } else {
          return 400
        }
      }
    },
    data() {
      return {
        vTooltip: false,
        computedPosition: ''
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .icon-info
    vertical-align middle
    color #BDBDBD

  .box-tooltip
    position absolute
    z-index 125
    top 0
    background-color white
    box-shadow 0 4px 4px rgba(0, 0, 0, 0.25)
    border-radius 4px
    padding 20px
    font-size 14px
    color #000000
    white-space pre-line
    line-height 18px
    font-weight 400
    text-align left

  .triangle
    position absolute
    left 50%
    bottom -9px
    width 10px
    height 10px
    background-color #242428
    transform rotate(45deg) translateX(-50%)

  .tool-tip-outside
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    z-index 120
    //background rgba(0,0,0, 0.3)

  .tool-tip-text
    white-space pre-line

  .tool-tip-text-primary
    padding-top 4px
    font-size 8px
    font-weight 300
    color #ff0000
    line-height 12px
</style>
